import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";

function ModelosDataTable({
  linhas,
  togNovoModeloModal,
  togEditarModeloModal,
  apagaModelo,
}) {
  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome do modelo",
        accessor: "nome",
        isSorted: true,
      },
      {
        Header: "Variáveis",
        accessor: "variaveis",
        disableSortBy: true,
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <CommonDropdown>
              <DropdownButton
                key={`editar-${row.original.uid}`}
                onClick={() => {
                  togEditarModeloModal(row.original.uid);
                }}
                color="success"
                icon="mdi mdi-account-edit"
              >
                Editar
              </DropdownButton>
              <DropdownButton
                key={`excluir-${row.original.uid}`}
                onClick={() => {
                  apagaModelo(row.original.uid);
                }}
                color="danger"
                icon="mdi mdi-delete"
              >
                Excluir
              </DropdownButton>
            </CommonDropdown>
          );
        },
      },
    ],
    [apagaModelo, togEditarModeloModal]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <ButtonRounded
          onClick={() => {
            togNovoModeloModal();
          }}
          color="success"
          icon={<FaPlus />}
        >
          Novo modelo
        </ButtonRounded>
      }
    />
  );
}

ModelosDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togNovoModeloModal: PropTypes.func.isRequired,
  togEditarModeloModal: PropTypes.func.isRequired,
  apagaModelo: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default ModelosDataTable;
